export const cookieUTG = 'user_has_seen_UTG';
